<div>
	<app-course-title>Pick a class to view progress</app-course-title>
	<app-journey-section-selector
		(onSectionSelected)="onSectionSelected.emit($event)"
		(onSectionsLoaded)="onSectionsLoaded.emit($event)"
	></app-journey-section-selector>
</div>
